<template>
	<div class="class">
		<studentNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></studentNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">我的作业</p>
				</div>
				<div class="my_task_screen mat30">
					<div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">学科</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in subject" :key="index" :class="{'on':item.subjectId==subject_cur}"
							 @click="subjectCheck(index)">{{item.subjectName}}</span>
						</div>
					</div>
					<div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">类型</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in type" :key="index" :class="{'on':item.id==type_cur}"
							 @click="typeCheck(index.id)">{{item.name}}</span>
						</div>
					</div>
					<div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">状态</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in status" :key="index" :class="{'on':item.id==status_cur}"
							 @click="statusCheck(item.id)">{{item.name}}</span>
						</div>
					</div>
				</div>
				<div class="f18px cl_gray mat20">总共 <span class="cl_yel">{{total}}</span> 条</div>
				<div class="my_task_cont mat10" v-if="list.length > 0">
					<div class="my_task_list flex cur" v-for="(item,index) in list" :key="index" @click="listCheck(item.id)">
						<div class="my_task_list_l">
							<div class="my_task_list_top">
								<span class="my_task_list_type cl_white tc" v-if="item.type == 'all'">混合</span>
								<span class="my_task_list_type cl_white tc video" v-if="item.type == 'video'">视频</span>
								<span class="my_task_list_type cl_white tc test" v-if="item.type == 'test'">组卷</span>
								<span class="my_task_list_type cl_white tc test" v-if="item.type == 'papers'">试卷</span>
								<span class="my_task_list_type cl_white tc test" v-if="item.type == 'exam'">校本试卷</span>
								<span class="my_task_list_subject cl_violet tc">{{item.subject_name}}</span>
								<span class="f20px cl_dark">{{item.name}}</span>
							</div>
							<div class="my_task_list_btm mat15 cl_gray">
								<p>开始时间：{{item.from_time}}</p>
								<p>截止时间：{{item.to_time}}</p>
								<p>布置人：{{item.add_user_name}}</p>
							</div>
						</div>
						<div class="my_task_list_r cl_violet tc">做作业</div>
					</div>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray"> </div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next"
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import studentNav from '../../components/student_nav.vue'
	
	export default {
		name: 'my_task',
		components: {
			studentNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 1,
					listCur: 0,
					open: 0,
				},
				subject: [],
				subject_cur: "",
				type: [
					{
						id: "",
						name: "全部",
					},{
						id: "video",
						name: "视频",
					},{
						id: "test",
						name: "组卷",
					},{
						id: "papers",
						name: "试卷",
					},{
						id: "exam",
						name: "校本试卷",
					},
				],
				type_cur: "",
				status: [
					{
						id: 1,
						name: "进行中",
					},{
						id: 2,
						name: "未开始",
					},{
						id: 3,
						name: "已截止"
					},
				],
				status_cur: 1,
				list: [],
				currentPage: 1, //当前页数
				pageSize: 10, //每页数量
				total: 0, //总页数
			}
		},
		created() {
			
		},
		mounted() {
			this.getSubject();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
					this.subject.unshift({subjectid: "", subjectName: "全部"});
					this.subject_cur = this.subject[0].subjectId;
					this.getList();
				});
			},
			subjectCheck (e) {
				this.subject_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			typeCheck (e) {
				this.type_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			statusCheck (e) {
				this.status_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			getList () {
				this.$get("/api/student/get_my_homework_list",{
					token: localStorage.getItem("token"),
					subject_id: this.subjcet_cur,
					type: this.type_cur,
					status: this.status_cur,
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.list = res.data.data;
					this.total = res.data.total;
				});
			},
			listCheck (id) {
				if (this.status_cur == 2) {
					this.$message({
						type: 'warning',
						message: '作业未开始',
						duration: 1500,
					});
					return false
				}
				this.$router.push({path: '/my_task_list', query: {id: id}});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
		},
	}
</script>

<style>
</style>
